import { DOCUMENT } from "@angular/common";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable, catchError } from "rxjs";
import {
  isCdnAssetUrl,
  isLocalAssetFallbackEnabled,
  toLocalAssetUrl,
} from "../utils/asset-url.util";

@Injectable()
export class AssetFallbackInterceptor implements HttpInterceptor {
  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (
      !isLocalAssetFallbackEnabled(this.document.location.hostname) ||
      !isCdnAssetUrl(request.url)
    ) {
      return next.handle(request);
    }

    return next
      .handle(request)
      .pipe(
        catchError(() =>
          next.handle(request.clone({ url: toLocalAssetUrl(request.url) })),
        ),
      );
  }
}
